<script setup>
  import { computed, ref } from 'vue';
  import TagItem from '@/components/Paragraphs/TagItem.vue';

  const activeItem = ref(0)

  const props = defineProps({
    textLeft: String,
    items: String
  })

  const items = computed(() => {
    if (!props.items) return false
    return JSON.parse(props.items)
  })

</script>

<template>
  <section
    class="element-tag ~mt-20/28 max-w-screen-2xl mx-auto px-6"
  >
    <GridLayout
      :hasGap="false"
    >
      <div
        class="left-placeholder lg:col-span-4"
      />
      <div
        class="element-tag-navigation lg:col-span-8 gap-12 flex flex-row items-baseline"
      >
        <div
          v-for="(item,index) in items"
          :key="index"
          class="element-tag-navigation-item pb-4 opacity-70 transition-all hover:opacity-100 cursor-pointer border-b-2 border-transparent"
          :class="index === activeItem ? 'active opacity-100 text-headline !border-headline' : ''"
          @click="activeItem = index"
        >
          {{ item.header }}
        </div>
      </div>
      <div
        class="left-headline border-t lg:col-span-4 pt-14"
        v-html="textLeft"
      />
      <div
        class="element-tag-items relative border-t grid grid-cols-2 xl:grid-cols-3 lg:gap-10 lg:col-span-8 ~pt-8/14"
      >
          <TagItem
            v-for="(item,index) in items"
            :key="index"
            class="element-tag-item absolute top-14 left-0"
            :class="index === activeItem ? 'active' : ''"
            :item="item"
          />
      </div>
    </GridLayout>
  </section>
</template>

<style lang="scss" scoped>
.element-tag-item {
  @apply opacity-0 transition-opacity duration-500;
  &.active {
    @apply opacity-100;
  }
}
.left-headline {
  :deep(p) {
    @apply uppercase mb-2 font-medium text-small-text ~text-xs/sm;
  }
  :deep(h1), :deep(h2) {
    @apply ~text-2xl/4xl font-normal mb-4;
  }
}
</style>
